import * as React from "react";
import "../style/result.css";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";

import { useState, useEffect } from "react";
import { baseURL } from "../config";

const Transition = React.forwardRef(function Transition(props, ref) {
  return (
    <Slide
      direction="left"
      ref={ref}
      {...props}
    />
  );
});

const History = (props) => {
  const { dialog, setDialog } = props;

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setDialog(false);
  };

  useEffect(() => {
    setOpen(true);

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(`${baseURL}gameHistory/result`, requestOptions)
      .then((response) => response.json())
      .then((res) => {
        setData(res.gameHistories);
      })
      .catch((error) => {
        console.error(error);
        setOpen(false);
      })
      .finally(() => {
        setOpen(false);
      });
  }, []);

  return (
    <Dialog
      fullScreen
      open={dialog}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{
        className: "history-dialog",
      }}
    >

      {/* ================= HEADER ================= */}

      <AppBar
        position="relative"
        className="history-appbar"
      >
        <Toolbar className="history-toolbar">

          <Typography
            variant="h6"
            component="div"
            className="history-title"
          >
            <span className="history-back">&lt;</span>
            History
          </Typography>

          <Button
            autoFocus
            onClick={handleClose}
            className="history-close"
          >
            CLOSE
          </Button>

        </Toolbar>
      </AppBar>


      {/* ================= MAIN HISTORY AREA ================= */}

      <div className="history-page">

        {/* ================= A B C ================= */}

        <div className="history-columns">

          <div className="history-column">
            <div className="history-letter letter-a">
              A
            </div>
          </div>

          <div className="history-column">
            <div className="history-letter letter-b">
              B
            </div>
          </div>

          <div className="history-column">
            <div className="history-letter letter-c">
              C
            </div>
          </div>

        </div>


        {/* ================= SCROLLABLE RESULTS ================= */}

        <div className="history-results">

          {open === true ? (

            <div className="history-loader">
              <div className="loader1">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

          ) : data?.length > 0 ? (

            data.map((history, i) => (

              <div
                key={i}
                className="history-row"
              >

                {history.cardCoin.map((item, j) => (

                  <div
                    key={j}
                    className="history-cell"
                  >

                    <div
                      className={
                        item.winner
                          ? "history-result win"
                          : "history-result lose"
                      }
                    >
                      {item.winner ? "Win" : "Lose"}
                    </div>

                  </div>

                ))}

              </div>

            ))

          ) : (

            <div className="history-no-data">
              No Data Found !!
            </div>

          )}

        </div>

      </div>

    </Dialog>
  );
};

export default History;
